var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 0.164062C2.332 0.164062 0 2.46226 0 5.28869V12.3844C0 15.2107 2.332 17.5089 5.2 17.5089H12.4C15.268 17.5089 17.6 15.2107 17.6 12.3844V5.28869C17.6 2.46226 15.268 0.164062 12.4 0.164062H5.2ZM13.6 3.31768C14.04 3.31768 14.4 3.67246 14.4 4.10609C14.4 4.53971 14.04 4.89449 13.6 4.89449C13.16 4.89449 12.8 4.53971 12.8 4.10609C12.8 3.67246 13.16 3.31768 13.6 3.31768ZM8.8 4.50029C11.228 4.50029 13.2 6.44371 13.2 8.83651C13.2 11.2294 11.228 13.1728 8.8 13.1728C6.372 13.1728 4.4 11.2294 4.4 8.83651C4.4 6.44371 6.372 4.50029 8.8 4.50029ZM8.8 5.28869C6.816 5.28869 5.2 6.88127 5.2 8.83651C5.2 10.7918 6.816 12.3844 8.8 12.3844C10.784 12.3844 12.4 10.7918 12.4 8.83651C12.4 6.88127 10.784 5.28869 8.8 5.28869Z",
    fill: "#F8D210"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.110d90fa10b7e6c618e106390eddc81b.svg";
export { ForwardRef as ReactComponent };